import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b47c2d7a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b47c2d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47c2d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b47c2d7a')) {
      api.createRecord('b47c2d7a', component.options)
    } else {
      api.reload('b47c2d7a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b47c2d7a&scoped=true&", function () {
      api.rerender('b47c2d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/comp/DocBox.vue"
export default component.exports